import { LevelAbbreviations } from "../Types";

export const FiasFlatTypes: LevelAbbreviations[] = [
    {
        long: "Не определено",
        short: "Не определено",
        fiasKey: "0",
        objectID: "1214",
    },
    {
        long: "Помещение",
        short: "помещ",
        fiasKey: "1",
        objectID: "1308",
    },
    {
        long: "Квартира",
        short: "кв",
        fiasKey: "2",
        objectID: "1303",
    },
    {
        long: "Офис",
        short: "офис",
        fiasKey: "3",
        objectID: "1301",
    },
    {
        long: "Комната",
        short: "ком",
        fiasKey: "4",
        objectID: "1304",
    },
    {
        long: "Рабочий участок",
        short: "раб.уч.",
        fiasKey: "5",
        objectID: "1207",
    },
    {
        long: "Склад",
        short: "скл.",
        fiasKey: "6",
        objectID: "1308",
    },
    {
        long: "Торговый зал",
        short: "торг. зал",
        fiasKey: "7",
        objectID: "1308",
    },
    {
        long: "Цех",
        short: "цех",
        fiasKey: "8",
        objectID: "1308",
    },
    {
        long: "Павильон",
        short: "пав",
        fiasKey: "9",
        objectID: "1308",
    },
    {
        long: "Подвал",
        short: "подв",
        fiasKey: "10",
        objectID: "1215",
    },
    {
        long: "Котельная",
        short: "кот.",
        fiasKey: "11",
        objectID: "1216",
    },
    {
        long: "Погреб",
        short: "п-б",
        fiasKey: "12",
        objectID: "1217",
    },
    {
        long: "Гараж",
        short: "г-ж",
        fiasKey: "13",
        objectID: "1211",
    },
    {
        long: "Машино-место",
        short: "м/м",
        fiasKey: "14",
        objectID: "1303",
    },
];
